import axios from 'axios';

export const updateCart = (csrfToken: string, formData: FormData) =>
  axios.post('/actions/commerce/cart/update-cart', formData, {
    headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' },
  });

export const addUser = (csrfToken: string, formData: FormData) =>
  axios.post('/actions/users/save-user', formData, {
    headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' },
  });

export const loginService = (csrfToken: string, formData: FormData) =>
  axios.post('/actions/users/login', formData, {
    headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' },
  });

// In-memory cache for ERP article responses to deduplicate identical requests
// (e.g. GSProductAmountWidget + GSSelectionWidget modal on the same page)
const articleCache: Record<string, Promise<any>> = {};

export const getArticle = (id: string, debtorId: string) => {
    const cacheKey = `${id}__${debtorId}`;
    if (!articleCache[cacheKey]) {
      const params = new URLSearchParams({ sku: id, debtorid: debtorId });
      articleCache[cacheKey] = axios
        .get(`/actions/casymir/products/get-article?${params}`)
        .then(response => response.data)
        .catch(error => {
          // Remove failed requests from cache so they can be retried
          delete articleCache[cacheKey];
          console.error(error);
          return null;
        });
    }
    return articleCache[cacheKey];
};